module.exports = {"submits":{"en":"Register now","cz":"Zaregistrovat!","sk":"Registrácia!","pl":"Zarejestruj","fr":"Inscrivez-vous","it":"Registrazione","es":"Registrarse","tr":"Kayıt olun","de":"Jetzt registrieren!","nl":"Registreer nu","sw":"Registrera dig","ru":"Регистрация","hu":"Regisztráció","fi":"Register now","se":"Registrera dig","da":"Tilmeld","no":"Register now","ro":"ÎNREGISTRARE"}}


// WEBPACK FOOTER //
// ./src/data/submits.json